import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

const ProtectedRoutes = () => {
  const isLoggedIn = sessionStorage.getItem('token')
  return isLoggedIn ? <Outlet /> : <Navigate to='/' />
}

export default ProtectedRoutes
